import axios from "axios";
import { GetToken } from "../helper";
import { API_ADDRESS } from "../index";

export interface ServiceRecordModel {
  id: number;
  recordNo: string;
  machineSerialNumber: string;
  serviceDate: string;
  serviceDocumentNo?: string;
  customerName?: string;
  customerPhone?: string;
  netAmount: number;
  netAmountCurrency: string;
  exchangeRate: number;
  createdDate: string;
  updatedDate?: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface ServiceRecordItemModel {
  id: number;
  serviceRecordId: number;
  materialId: number;
  materialStockCode: string;
  materialName: string;
  materialPrice: number;
  materialCurrency: string;
  quantity: number;
  totalAmount: number;
  isLabor?: boolean; // İşçilik alanı mı?
  laborPrice?: number; // İşçilik fiyatı
  laborCurrency?: string; // İşçilik para birimi
}

export interface ServiceRecordCreateModel {
  machineSerialNumber: string;
  serviceDate: string;
  serviceDocumentNo?: string;
  customerName?: string;
  customerPhone?: string;
  netAmount: number;
  netAmountCurrency: string;
  serviceUserMail: string;
  items: ServiceRecordItemCreateModel[];
}

export interface ServiceRecordItemCreateModel {
  id?: string; // Unique identifier for React key
  materialId: number;
  quantity: number;
  isLabor?: boolean; // İşçilik alanı mı?
  laborPrice?: number; // İşçilik fiyatı
  laborCurrency?: string; // İşçilik para birimi
}

export interface ServiceRecordSearchModel {
  searchTerm?: string;
  machineSerialNumber?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
}

export interface ServiceRecordResponseModel {
  success: boolean;
  message: string;
  data?: any;
  errors?: string[];
}

export interface ServiceRecordListResponse {
  serviceRecords: ServiceRecordModel[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface ServiceRecordDetailModel {
  serviceRecord: ServiceRecordModel;
  items: ServiceRecordItemModel[];
  totalAmountTL: number;
  totalAmountUSD: number;
  totalAmountEUR: number;
}

export class ServiceRecordService {
  static async getServiceRecords(
    searchModel: ServiceRecordSearchModel
  ): Promise<ServiceRecordResponseModel> {
    try {
      const params = new URLSearchParams();
      if (searchModel.searchTerm)
        params.append("searchTerm", searchModel.searchTerm);
      if (searchModel.machineSerialNumber)
        params.append("machineSerialNumber", searchModel.machineSerialNumber);
      if (searchModel.startDate)
        params.append("startDate", searchModel.startDate);
      if (searchModel.endDate) params.append("endDate", searchModel.endDate);
      if (searchModel.page) params.append("page", searchModel.page.toString());
      if (searchModel.pageSize)
        params.append("pageSize", searchModel.pageSize.toString());

      const response = await axios.get(
        `${API_ADDRESS}/api/ServiceRecord/GetServiceRecords?${params.toString()}`,
        {
          headers: {
            Authorization: "Bearer " + GetToken(),
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error getting service records:", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Servis kayıtları getirilirken hata oluştu",
      };
    }
  }

  static async getServiceRecord(
    id: number
  ): Promise<ServiceRecordResponseModel> {
    try {
      const response = await axios.get(
        `${API_ADDRESS}/api/ServiceRecord/GetServiceRecord/${id}`,
        {
          headers: {
            Authorization: "Bearer " + GetToken(),
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error getting service record:", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Servis kaydı getirilirken hata oluştu",
      };
    }
  }

  static async createServiceRecord(
    serviceRecord: ServiceRecordCreateModel
  ): Promise<ServiceRecordResponseModel> {
    try {
      const response = await axios.post(
        `${API_ADDRESS}/api/ServiceRecord/CreateServiceRecord`,
        serviceRecord,
        {
          headers: {
            Authorization: "Bearer " + GetToken(),
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error creating service record:", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Servis kaydı oluşturulurken hata oluştu",
      };
    }
  }

  static async deleteServiceRecord(
    id: number
  ): Promise<ServiceRecordResponseModel> {
    try {
      const response = await axios.delete(
        `${API_ADDRESS}/api/ServiceRecord/DeleteServiceRecord/${id}`,
        {
          headers: {
            Authorization: "Bearer " + GetToken(),
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error deleting service record:", error);
      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Servis kaydı silinirken hata oluştu",
      };
    }
  }
}
